import auth from '@/api/auth.js';

const authHeaders = () => ({ Authorization: 'Bearer ' + auth.getAuthHeader() });

export default {
  searchAirports(http, keyword,lang) {
    return http.post(
      auth.BOOKING_API_URL + 'Airport/GetWithQueryInternational',
      { query: keyword, lang: lang },
      { headers: authHeaders() }
    );
  },
  getCompany(http, sirketKodu) {
    return http.post(
      auth.API_URL + 'api/Parameters/CompanyGet',
      { SirketKodu: sirketKodu },
      { headers: authHeaders() }
    );
  },

  checkExtraProduct(http) {
    return http.post(
      auth.API_URL + 'api/Awed/ExtraProductGroupList',
      { GrupID: null, UrunID: null, MusteriID: null },
      { headers: authHeaders() }
    );
  },

  checkAgency(http, email, taxNo) {
    return http.post(
      auth.BOOKING_API_URL + 'Agency/CheckAgency',
      { Email: email, TaxNo: taxNo },
      { headers: authHeaders() }
    );
  },

  addAgency(http, firma) {
    return http.post(
      auth.BOOKING_API_URL + 'Agency/AddAgency',
      { ...firma, IsActive: true, CountryCode: 'TR' },
      { headers: authHeaders() }
    );
  },

  login(http, username, password) {
    return http.post(
      auth.BOOKING_API_URL + 'Login',
      { Username: username, Password: password, IsTest: false },
      { headers: authHeaders() }
    );
  },

  getCredentials(http, sessionHeader) {
    return http.post(
      auth.BOOKING_API_URL + 'Agency/GetCredential',
      { SessionHeader: sessionHeader },
      { headers: authHeaders() }
    );
  },

  getAirlineList(http, companyCode) {
    return http.post(
      auth.API_URL + 'api/TicketDefinitons/AirlineList',
      { CompanyCode: companyCode },
      { headers: authHeaders() }
    );
  },

  addCredential(http, params) {
    return http.post(
      auth.BOOKING_API_URL + 'Agency/AddCredential',
      params,
      { headers: authHeaders() }
    );
  },

  editCredential(http, params) {
    return http.post(
      auth.BOOKING_API_URL + 'Agency/EditCredential',
      params,
      { headers: authHeaders() }
    );
  },
  getShoppingCart(http, sessionHeader) {
    return http.post(
      auth.BOOKING_API_URL + 'ShoppingCart/GetShoppingCart',
      { SessionHeader: sessionHeader },
      { headers: authHeaders() }
    );
  }
};
